import { defineMessages } from 'react-intl';

const messages = defineMessages({
  signOut: {
    id: 'baseLayout.signOut',
    defaultMessage: 'Log out',
  },
  profile: {
    id: 'baseLayout.profile',
    defaultMessage: 'Profile',
  },
  donations: {
    id: 'baseLayout.donations',
    defaultMessage: 'Donations',
  },
  users: {
    id: 'baseLayout.users',
    defaultMessage: 'Users',
  },
  documents: {
    id: 'baseLayout.documents',
    defaultMessage: 'Documents',
  },
  yourApplication: {
    id: 'baseLayout.yourApplication',
    defaultMessage: 'Your application',
  },
  helpCenter: {
    id: 'baseLayout.helpCenter',
    defaultMessage: 'Help centre',
  },
  settings: {
    id: 'baseLayout.settings',
    defaultMessage: 'Settings',
  },
  more: {
    id: 'baseLayout.more',
    defaultMessage: 'More',
  },
  navigationA11y: {
    id: 'baseLayout.navigationA11y',
    defaultMessage: 'Navigation',
  },
});

export default messages;
